export default ({serviceDetails: [{itineraries = []}], supplierCompanyName}) => ({
    itinerary: itineraries.map(({flightSegments}) => ({
        segments: flightSegments.map(
            ({operatingAirline, marketingAirline, departureAirportCode, arrivalAirportCode}) => ({
                operatingAirline,
                marketingAirline,
                departure: {
                    airportDescription: {airportName: '', cityName: ''},
                    airportCode: departureAirportCode,
                },
                arrival: {
                    airportDescription: {airportName: '', cityName: ''},
                    airportCode: arrivalAirportCode,
                },
            })
        ),
    })),
    supplierName: supplierCompanyName,
})
